import styled from 'styled-components'

export const Container = styled.div``

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  text-transform: uppercase;
  border-radius: ${props => props.theme.primitives.radius.radius1};
  color: ${props => props.theme.colors.text.subtle};
  padding: ${props => props.theme.spacing.sp8};
  margin-bottom: ${props => props.theme.spacing.sp8};

  & > div:last-child {
    display: flex;
    gap: ${props => props.theme.spacing.sp8};
  }
`

export const TableHeaderItem = styled.div`
  padding: 0 ${props => props.theme.spacing.sp8};
  min-width: ${props => props.minWidth || 'auto'};
  text-align: right;
`

export const RefundMethodsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const RefundMethodContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.spacing.sp8};
`

export const RefundMethodLeftCol = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const RefundMethodBullet = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius6};
  height: 8px;
  width: 8px;
`

export const RefundMethodNameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
`

export const RefundMethodRightCol = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const RefundMethodStatCol = styled.div`
  padding: 0 ${props => props.theme.spacing.sp8};
  min-width: ${props => props.minWidth || 'auto'};
  text-align: right;
`

export const TotalsContainer = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.sp32};
`
